import { render, staticRenderFns } from "./viewArticles.vue?vue&type=template&id=97103f34&scoped=true&"
import script from "./viewArticles.vue?vue&type=script&lang=js&"
export * from "./viewArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97103f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97103f34')) {
      api.createRecord('97103f34', component.options)
    } else {
      api.reload('97103f34', component.options)
    }
    module.hot.accept("./viewArticles.vue?vue&type=template&id=97103f34&scoped=true&", function () {
      api.rerender('97103f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gateway/components/viewArticles.vue"
export default component.exports